<div class="container">
    @if (historik) {
    <div class="row">
        <rask-list class="event-table" [data]="historik">
            <rask-list-column header="Publicerad datum" field="publiceradDatum">
                <ng-template let-row="row">
                    <a
                        (click)="close()"
                        [routerLink]="['/produktinstruktioner', data.puid]"
                        [queryParams]="{ historikId: row.id }">
                        {{ dateFormat(row.publiceradDatum) }}
                    </a>
                    <a
                        [routerLink]="['/produktinstruktioner', data.puid]"
                        [queryParams]="{ historikId: row.id }"
                        target="_blank">
                        <i class="far fa-sm fa-external-link p-r-half"></i>
                    </a>
                </ng-template>
            </rask-list-column>
            <rask-list-column header="Publicerad av" field="publiceradAv"></rask-list-column>
            <rask-list-column header="Version" field="version"></rask-list-column>
        </rask-list>
    </div>
    }
</div>
<div class="modal-footer">
    <rask-button color="secondary" (click)="dismiss()">Stäng</rask-button>
</div>